export const identity = <T>(x: T) => x

export const identityAny = identity as (x: any) => any
